import React from 'react';
import ProtectedSwagger from '../components/ProtectedSwagger';
import { services } from '../config/services';

const service = services.find((item) => item.route === '/nom151');

const DicioBackFintechPagosMiddlewareAPIDoc = () => (
    <ProtectedSwagger
        service={service}
        url={process.env.PUBLIC_URL + '/json/openapi_fintech_pagos/dicio-back-middleware-fintech-pagos-openapi.json'}
    />
);

export default DicioBackFintechPagosMiddlewareAPIDoc;
